export const ROLE_DEFINITIONS = "/Role/GetRoles"
export const ROLE_INSERT = "/Role/InsertRole"
export const ROLE_UPDATE = "/Role/UpdateRole"
export const ROLE_DELETE = "/Role/DeleteRole" 